import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { AppConfigurationService } from 'app/shared/app-configuration';

export const redirectToV2Guard: CanActivateFn = (_route, state) => {
    const appConfigurationService = inject(AppConfigurationService);
    const frontendWebV2Url = appConfigurationService.configuration.uris.frontendWebV2Url;
    const smartInsights = 'smart-insights';

    if (state.url.endsWith('/home')) {
        window.open(frontendWebV2Url, '_self');
        return false;
    }

    if (state.url.endsWith(`/${smartInsights}`)) {
        window.open(`${frontendWebV2Url}${smartInsights}`, '_self');
        return false;
    }

    return true;
};
